import React, { useContext, useState } from "react";

import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";

const PendingActionConfirmation = ({ setPendingAction }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { registration, setFormModal } = adminRegistrationContext;
  const { status } = registration;
  return (
    <div className="pending-action-confirm">
      <p>{`Is the ${status.replace("Requested", "")} completed?`}</p>
      <div className="btn-container">
        <div
          className="btn btn-llac-dark-green"
          onClick={() => setPendingAction(false)}
        >
          Yes
        </div>
        <div
          className="btn btn-llac-dark-green"
          onClick={() => setFormModal("processRegistrationModal", false)}
        >
          Still Pending
        </div>
      </div>
    </div>
  );
};

export default PendingActionConfirmation;
